import { render, staticRenderFns } from "./AddTransfer.vue?vue&type=template&id=26bae6f8&scoped=true"
import script from "./AddTransfer.vue?vue&type=script&lang=js"
export * from "./AddTransfer.vue?vue&type=script&lang=js"
import style0 from "./AddTransfer.vue?vue&type=style&index=0&id=26bae6f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bae6f8",
  null
  
)

export default component.exports